module.exports = __webpack_public_path__ + "img/PostNL.8920180e.png";